import React from "react";
import Chart from "react-apexcharts";

const EMPTY_COLORS = ["#E5E7EB", "#D1D5DB", "#9CA3AF"];

const getDummyConfig = (type) => {
  switch (type) {
    case "donut":
    case "pie":
      return {
        series: [40, 30, 30],
        options: {
          chart: { type },
          labels: ["", "", ""],
          colors: EMPTY_COLORS,
          dataLabels: { enabled: false },
          legend: { show: false },
          stroke: { width: 0 },
          tooltip: { enabled: false },
        },
      };

    case "bar":
      return {
        series: [{ data: [10, 20, 15, 25, 18] }],
        options: {
          chart: { type: "bar", toolbar: { show: false } },
          colors: ["#e8e8e8"],
          plotOptions: {
            bar: {
              borderRadius: 4,
              columnWidth: "45%",
            },
          },
          dataLabels: { enabled: false },
          xaxis: {
            labels: { show: true },
            axisBorder: { show: true },
            axisTicks: { show: true },
          },
          yaxis: { show: true },
          grid: { show: false },
          tooltip: { enabled: false },
        },
      };

    case "line":
    case "area":
      return {
        series: [{ data: [10, 25, 10, 15, 28] }],
        options: {
          chart: { type, toolbar: { show: false } },
          colors: ["#D1D5DB"],
          stroke: {
            curve: "smooth",
            width: 3,
          },
          fill: type === "area" ? { opacity: 0.3 } : { opacity: 1 },
          dataLabels: { enabled: false },
          markers: { size: 0 },
          xaxis: {
            labels: { show: true },
            axisBorder: { show: true },
            axisTicks: { show: true },
          },
          yaxis: { show: true },
          grid: { show: false },
          tooltip: { enabled: false },
        },
      };

    default:
      return {};
  }
};

const EmptyChart = ({
  type = "donut",
  height = 340,
  title = "No data available",
}) => {
  const config = getDummyConfig(type);

  return (
    <div
      style={{
        position: "relative",
        height,
        width: "100%",
      }}
    >
      {/* Dummy chart */}
      <Chart
        options={config.options}
        series={config.series}
        type={type}
        height={height}
      />

      {/* Overlay message */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255,255,255,0.75)",
          textAlign: "center",
          padding: 16,
        }}
      >
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#374151",
            fontFamily: "sans-serif",
            fontStyle: "italic",
          }}
        >
          {title}
        </div>
        {/* <div
          style={{
            fontSize: 12,
            color: "#6B7280",
            marginTop: 4,
            fontFamily: "sans-serif",
          }}
        >
          {subtitle}
        </div> */}
      </div>
    </div>
  );
};

export default EmptyChart;
